import React from "react";
import styled from "styled-components/macro";

const StyledSvg = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
`;

export const ProfileIcon: React.FC<{ className?: string; fill?: string }> = ({
  className,
  fill,
}) => {
  return (
    <>
      <StyledSvg
        viewBox="0 0 20 20"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M10.0002 4.91659C10.9668 4.91659 11.7502 5.69992 11.7502 6.66658C11.7502 7.63325 10.9668 8.41659 10.0002 8.41659C9.0335 8.41659 8.25016 7.63325 8.25016 6.66658C8.25016 5.69992 9.0335 4.91659 10.0002 4.91659ZM10.0002 12.4166C12.4752 12.4166 15.0835 13.6333 15.0835 14.1666V15.0833H4.91683V14.1666C4.91683 13.6333 7.52516 12.4166 10.0002 12.4166ZM10.0002 3.33325C8.1585 3.33325 6.66683 4.82492 6.66683 6.66658C6.66683 8.50825 8.1585 9.99992 10.0002 9.99992C11.8418 9.99992 13.3335 8.50825 13.3335 6.66658C13.3335 4.82492 11.8418 3.33325 10.0002 3.33325ZM10.0002 10.8333C7.77516 10.8333 3.3335 11.9499 3.3335 14.1666V16.6666H16.6668V14.1666C16.6668 11.9499 12.2252 10.8333 10.0002 10.8333Z" />
      </StyledSvg>
    </>
  );
};
